import { ITourMainProps, ITourItemViewModel } from './interface';

const dummyItem: ITourItemViewModel = {
    title: {
        text: '',
        fontFamily: 'Gill Sans',
        fontSize: '10vmin',
        lineHeight: '10vmin',
        fontAlignment: 'center',
        fontWeight: 500,
        color: '#000',
        visible: true,
    },
    titleBackgroundColor: '#ddd',

    backgroundImage: {
        mode: 'contain',
        url: '',
    },
    backgroundColor: '#fff',
    cornerRadius: 2,

    number: {
        text: '',
        fontFamily: 'Gill Sans',
        fontSize: '10vmin',
        lineHeight: '10vmin',
        fontAlignment: 'center',
        fontWeight: 500,
        color: '#ddd',
        visible: true,
    },
    numberBackgroundColor: '#000',
    shouldGrayAfterViewing: true,
    subItems: [],

    onClick: (item: ITourItemViewModel) => {},
};

function placeholderData(): ITourMainProps {
    return {
        sideMenu: {
            backgroundColor: '#000',
            foregroundImage: {
                url: '',
                mode: 'contain',
            },
            items: [],
        },
        topBar: {
            title: {
                text: '',
                fontFamily: 'Gill Sans',
                fontSize: '10vmin',
                lineHeight: '10vmin',
                fontAlignment: 'center',
                fontWeight: 500,
                color: '#000000',
                visible: true,
            },
            backgroundColor: '#000',
            iconColor: '#fff',
        },

        backgroundColor: '#ffffff',
        backgroundImage: {
            url: '',
            mode: 'contain',
        },
        backButton: {
            backgroundColor: 'transparent',
            strokeColor: 'transparent',
            strokeSize: '0',
            arrowColor: 'transparent',
            visible: false,
        },
        collection: {
            backgroundColor: '#fff',
            backgroundImage: {
                url: '',
                mode: 'contain',
            },
            items: [dummyItem, dummyItem, dummyItem, dummyItem],
        },
        showFloorPlanIcon: false,
        onBack: () => {},
        onFloorPlanSelect: () => {},
    };
}

export default placeholderData;
